import styled from "styled-components"
import {
  Modal as BaseModal,
  type ModalProps as BaseModalProps,
} from "~/ur-react-components"

type ModalWrapperProps = {}

const ModalWrapper = styled.div<ModalWrapperProps>``

export interface ModalProps extends BaseModalProps {}

export const Modal: React.CFC<ModalProps> = ({ ...props }) => {
  return (
    <ModalWrapper>
      <BaseModal {...props} />
    </ModalWrapper>
  )
}
